<template>
    <div class="p-4">
      <l-container class="mb-4">
          <l-container-title slot="toolbar" text="Observations" icon="network-wired" color="bg-pastel-purple"  />
          <l-csv-import @on-import="onImportObservations" />
      </l-container>
    </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import ObservationsService from "./observations.service";
import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";

export default {
  name: "observations",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport
  },
  data() {
    return {
      edit: false,
      loading: false,
      observations: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      selected: {}
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {    
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.observations = await ObservationsService.observations();
    },
    // async deleteObservations(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await Observations.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Observations deleted!");
    //   }
    // },
    async saveObservations(ra) {
      const rowsAffected = await ObservationsService.update(ra);
      console.log("SAVED TO DB");
      const current = this.observations.find(n => n.id == ra.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ra[prop];
          }
        }
      }
    },
    async importObservations(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await ObservationsService.import(formData);
      this.observations = await ObservationsService.observations();
      Notify.success("Observations imported!");
    },
    async onImportObservations(file) {
      await Notify.loadData("Importing Observations", this.importObservations, file);
    },
    onEditObservations(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.edit = true;
    },
    onDeleteObservations(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              const rowsAffected = await ObservationsService.delete(row.id);
              const activeEditor = hot.getActiveEditor();
              hot.alter("remove_row", clickedRow, 1);
            }
          );
          Notify.success("Observations deleted!");
        }
      }, "This will delete all data connected to these Observations. <br/><br/>Do you want to continue?");
    },

    async onSaveObservations(observations) {
      await Notify.loadData(
        "Saving changes to Observations " + observations.id,
        this.saveObservations,
        observations
      );
      this.selected = {};
    }
  }
};
</script>

